//@flow
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ParentEnum } from '@bfg/enums/ParentEnum'
import { usePageSizeExperiment } from '@bfg/contexts/ExperimentsContext'

export const LeftBox = (props: any) => {
  const { t } = useTranslation()
  const pageSizeExperiment = usePageSizeExperiment()
  const goodPhoto = props.parent === ParentEnum.firstParent ? '/img/good-photo.jpg' : '/img/good-photo2.jpg'
  const badPhoto = props.parent === ParentEnum.firstParent ? '/img/bad-photo.jpg' : '/img/bad-photo2.jpg'
  return (<div className="left-box">
      <div className="inner-wrap">

        <div className="desktop-description">
          {props.parent === ParentEnum.firstParent && (<div className="page-icon-box">
              <h2 className="box-title">
                {/*<img src="/img/icon-image@2x.png" className="icon-img title-icon"/>*/}
                {t('experiments.pageShort.parent.leftBox.Upload your photo to generate a baby')}
              </h2>
            </div>)}
          {props.parent === ParentEnum.secondParent && (<div className="page-icon-box bm-icon">
              <h2 className="box-title">
                <span className="bm_icon_couple title-icon"/>
                {t('experiments.pageShort.parent.leftBox.Upload your partner\'s photo')}
              </h2>
            </div>)}
        </div>

        {/*{pageSizeExperiment === PageSizeExperiment.long &&*/}
        {/*  <>*/}
        {/*    {props.parent === ParentEnum.firstParent && (*/}
        {/*      <div className="page-icon-box">*/}
        {/*        <h2 className="box-title">*/}
        {/*          <img src="/img/icon-image@2x.png" className="icon-img title-icon"/>*/}
        {/*          {t('parent.leftBox.Upload your photo to generate a baby')}*/}
        {/*        </h2>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*    {props.parent === ParentEnum.secondParent && (*/}
        {/*      <div className="page-icon-box bm-icon">*/}
        {/*        <h2 className="box-title">*/}
        {/*          <span className="bm_icon_couple title-icon"/>*/}
        {/*          {t("parent.leftBox.Upload your partner's photo")}*/}
        {/*        </h2>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  </>*/}
        {/*}*/}


        <div className="example-photo-list-wrap">

          <div className="mobile-description">
            {props.parent === ParentEnum.firstParent && (<div className="page-icon-box">
                <h2 className="box-title">
                  {/*<img src="/img/icon-image@2x.png" className="icon-img title-icon"/>*/}
                  {t('experiments.pageShort.parent.leftBox.Upload your photo to generate a baby')}
                </h2>
              </div>)}
            {props.parent === ParentEnum.secondParent && (<div className="page-icon-box bm-icon">
                <h2 className="box-title">
                  <span className="bm_icon_couple title-icon"/>
                  {t('experiments.pageShort.parent.leftBox.Upload your partner\'s photo')}
                </h2>
              </div>)}

            {props.parent === ParentEnum.firstParent && <div className="content">
              <ul>
                <li>{t('experiments.pageShort.parent.leftBox.Start by uploading your photo or taking a selfie')}</li>
                <li>{t('experiments.pageShort.parent.leftBox.The face should be frontal, clearly visible, no glasses')}</li>
                <li>{t('experiments.pageShort.parent.leftBox.The face should occupy at least 70% of the photo')}</li>
              </ul>
            </div>}
            {props.parent === ParentEnum.secondParent && <div className="content">
              <ul>
                <li>{t('experiments.pageShort.parent.leftBox.Proceed by uploading your partner\'s photo below')}</li>
                <li>{t('experiments.pageShort.parent.leftBox.Face should be frontal, clearly visible, no glasses')}</li>
                <li>{t('experiments.pageShort.parent.leftBox.The face in the photo should occupy at least 70%')}</li>
              </ul>
            </div>}
          </div>
          <ul className="example-photo-list">
            <li className={'first-example-photo'}>
              <div className="centered-img">
                <img src={goodPhoto} alt={t('parent.leftBox.Good Photo')}/>
              </div>
            </li>
            <li className="bad">
              <div className="centered-img">
                <img src={badPhoto} alt={t('parent.leftBox.Bad Photo')}/>
              </div>
            </li>
          </ul>
        </div>

        <div className="desktop-description">
          {props.parent === ParentEnum.firstParent && <div className="content">
            <ul>
              <li>{t('experiments.pageShort.parent.leftBox.Start by uploading your photo or taking a selfie')}</li>
              <li>{t('experiments.pageShort.parent.leftBox.The face should be frontal, clearly visible, no glasses')}</li>
              <li>{t('experiments.pageShort.parent.leftBox.The face should occupy at least 70% of the photo')}</li>
            </ul>
          </div>}
          {props.parent === ParentEnum.secondParent && <div className="content">
            <ul>
              <li>{t('experiments.pageShort.parent.leftBox.Proceed by uploading your partner\'s photo below')}</li>
              <li>{t('experiments.pageShort.parent.leftBox.Face should be frontal, clearly visible, no glasses')}</li>
              <li>{t('experiments.pageShort.parent.leftBox.The face in the photo should occupy at least 70%')}</li>
            </ul>
          </div>}
        </div>

        {/*{pageSizeExperiment === PageSizeExperiment.long &&*/}
        {/*  <>*/}
        {/*    {props.parent === ParentEnum.firstParent &&*/}
        {/*      <div className="content">*/}
        {/*        <ul>*/}
        {/*          <li>{t('parent.leftBox.Start by uploading your photo or taking a selfie')}</li>*/}
        {/*          <li>{t('parent.leftBox.The face should be frontal, clearly visible, no glasses')}</li>*/}
        {/*          <li>{t('parent.leftBox.The face should occupy at least 70% of the photo')}</li>*/}
        {/*        </ul>*/}
        {/*      </div>*/}
        {/*    }*/}
        {/*    {props.parent === ParentEnum.secondParent &&*/}
        {/*      <div className="content">*/}
        {/*        <ul>*/}
        {/*          <li>{t("parent.leftBox.Proceed by uploading your partner's photo below")}</li>*/}
        {/*          <li>{t("parent.leftBox.Face should be frontal, clearly visible, no glasses")}</li>*/}
        {/*          <li>{t("parent.leftBox.The face in the photo should occupy at least 70%")}</li>*/}
        {/*        </ul>*/}
        {/*      </div>*/}
        {/*    }*/}
        {/*  </>*/}
        {/*}*/}


      </div>
    </div>)
}
export const LeftBoxNew = (props: any) => {
  const { t } = useTranslation()
  const pageSizeExperiment = usePageSizeExperiment()
  const goodPhoto = props.parent === ParentEnum.firstParent ? '/img/good-photo.jpg' : '/img/good-photo2.jpg'
  const badPhoto = props.parent === ParentEnum.firstParent ? '/img/bad-photo.jpg' : '/img/bad-photo2.jpg'
  return (<div className="left-box new">
      <div className="inner-wrap">
        {props.parent === ParentEnum.firstParent && (<div className="page-icon-box">
            <h2 className="box-title">
              <img src="/img/icon-image@2x.png" className="icon-img title-icon"/>
              {t('parent.leftBox.Upload your photo to generate a baby')}
            </h2>
          </div>)}
        {props.parent === ParentEnum.secondParent && (<div className="page-icon-box bm-icon">
            <h2 className="box-title">
              <span className="bm_icon_couple title-icon"/>
              {t('parent.leftBox.Upload your partner\'s photo')}
            </h2>
          </div>)}

        <div className="example-photo-list-wrap">
          <ul className="example-photo-list">
            <li className={'first-example-photo'}>
              <div className="centered-img">
                <img src={goodPhoto} alt={t('parent.leftBox.Good Photo')}/>
              </div>
            </li>
            <li className="bad">
              <div className="centered-img">
                <img src={badPhoto} alt={t('parent.leftBox.Bad Photo')}/>
              </div>
            </li>
          </ul>
        </div>

        {props.parent === ParentEnum.firstParent && <div className="content">
          <ul>
            <li>{t('parent.leftBox.Start by uploading your photo or taking a selfie')}</li>
            <li>{t('parent.leftBox.The face should be frontal, clearly visible, no glasses')}</li>
            <li>{t('parent.leftBox.The face should occupy at least 70% of the photo')}</li>
          </ul>
        </div>}
        {props.parent === ParentEnum.secondParent && <div className="content">
          <ul>
            <li>{t('parent.leftBox.Proceed by uploading your partner\'s photo below')}</li>
            <li>{t('parent.leftBox.Face should be frontal, clearly visible, no glasses')}</li>
            <li>{t('parent.leftBox.The face in the photo should occupy at least 70%')}</li>
          </ul>
        </div>}

      </div>
    </div>)
}
